module.exports = __webpack_public_path__ + "media/assets/icons/pen-38a855e12ed99c1db144a494929ee68f.svg";